// import react and related
/* eslint-disable  no-undef  */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import MUI objects
import { makeStyles } from '@mui/styles';
import { Box, Hidden, useMediaQuery, Grid, Container } from '@mui/material';

// import components
import Chat from './components/Chat';
import ChatList from './components/ChatList';
import ChatsFilter from './components/ChatsFilter';
import PatientPopup from '../../shared/Popups/PatientPopup';
import LoadingSpinner from '../../shared/LoadingSpinner/LoadingSpinner';
import CustomDFMessengerChat from '../../shared/CustomDFMessengerChat/CustomDFMessengerChat';

// other imports
import moment from 'moment';
import { actions } from '../../actions';
import { isEmpty } from 'lodash';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    activeChatsWrapper: {
      overflow: 'hidden',
      maxHeight: '100dvh',
      height: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    messengerContainer: {
      height: '100%' /* Ocupa todo el alto disponible */,
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end' /* Alineado a la izquierda */,
    },
    buttons: {
      zIndex: 10,
      borderRadius: '10px 0 0 10px',
      width: 45,
      position: 'fixed',
      right: 0,
      background: '#eee',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    activeChats: {
      height: '100%',
      overflow: 'hidden',
      flex: 1,
    },
    chatsLy: {
      marginTop: small && '64px',
      height: (small && 'calc(100dvh - 64px)') || '100%',
      position: 'relative',
    },
    appBar: {
      display: 'block',
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      overflow: 'auto',
      height: '100%',
      borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    },
    contentLy: {
      height: small ? '100dvh' : '100%',
      width: '100%',
    },
    chatListContainer: {
      height: '100%',
      margin: 0,
      padding: 0,
      overflow: 'auto',
      background: '#f4f4f4',
    },
    list: {
      paddingBottom: '0px',
      height: '100%',
      paddingTop: 0,
    },
    heightSmall: {
      height: '100%',
    },
    button: {
      cursor: 'pointer',
      '&:hover': {
        opacity: '.7',
      },
      margin: '4px 0',
      display: 'flex',
      alignItems: 'center',
    },
    searchButton: {
      width: 20,
      height: 20,
      color: '#282929',
    },
    settingsButton: {
      width: 20,
      height: 20,
      color: '#282929',
    },
    patientData: {
      background: theme.palette.white.main,
      zIndex: 3,
    },
  }));
};

export default function ActiveChats() {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const organization = useSelector((state) => state.app.organization);
  const appDispatch = useDispatch();
  const [lastOrganizationId, setLastOrganizationId] = useState();
  const chatId = useSelector((state) => state.app.activeChat);
  const filter = useSelector((state) => state.app.filter);
  const patientPopup = useSelector((state) => state.app.patientPopup);

  // rerender for update last message info
  // const [, setCount] = useState(0);
  // useEffect(() => {
  //   setInterval(() => {
  //     setCount((prevState) => {
  //       return prevState + 1;
  //     });
  //   }, 30000);
  // }, []);

  useEffect(() => {
    appDispatch({ type: actions.filterDate, date: moment() });
  }, [appDispatch]);

  useEffect(() => {
    if (organization.id && organization.id !== lastOrganizationId) {
      setLastOrganizationId(organization.id);
      appDispatch({ type: actions.activeChat, id: null });
    }
    localStorage.removeItem('prices');
    localStorage.removeItem('date');
    localStorage.removeItem('isV2');
    localStorage.removeItem('prepago');
    localStorage.removeItem('lastBillPrepago');
    localStorage.removeItem('isFirstMonth');
    localStorage.removeItem('recordatoriosALiquidar');
    localStorage.removeItem('totalsRecordatorios');
    localStorage.removeItem('newNotificationsFilters');
  }, [appDispatch, lastOrganizationId, organization, setLastOrganizationId]);

  useEffect(() => {
    appDispatch({ type: actions.activeChat, id: null });
  }, [appDispatch, filter.query.date]);

  return organization.id ? (
    <div className={classes.activeChatsWrapper}>
      <Hidden smDown>
        <ChatsFilter />
      </Hidden>
      <Grid display="flex" container spacing={0} className={classes.activeChats}>
        {(!chatId || !small) && (
          <Grid item xs={12} sm={3} className={classes.chatsLy}>
            <Box
              style={{ display: patientPopup && patientPopup.open ? 'flex' : 'none' }}
              width="100%"
              height="100%"
              position="absolute"
              flexDirection="column"
              className={classes.patientData}
            >
              <PatientPopup
                handleSubmit={(patient) => {
                  let message = `NOMBRES: ${patient.name} APELLIDOS: ${patient.surname} DNI: ${patient.dni} OBRA SOCIAL Y PLAN: ${patient.os} - ${patient.plan} FECHA DE NACIMIENTO: ${patient.bornDate} `;
                  if (!isEmpty(patient.gender)) message += ` GENERO: ${patient.gender}`;
                  if (!isEmpty(patient.email)) message += ` EMAIL: ${patient.email}`;

                  if (patient.kinship) {
                    message += ` RELACION: ${patient.kinship}`;
                  }
                  appDispatch({
                    type: actions.openPatientPopup,
                    patientPopup: {
                      open: false,
                      initProcess: false,
                      submit: true,
                      message,
                    },
                  });
                }}
              />
            </Box>
            <main className={classes.content}>
              <Container maxWidth="lg" className={classes.chatListContainer}>
                <Grid container spacing={0} className={classes.heightSmall}>
                  <Grid item xs={12} className={classes.heightSmall}>
                    <ChatList />
                  </Grid>
                </Grid>
              </Container>
            </main>
          </Grid>
        )}
        {chatId ? (
          <Grid item xs={12} sm={9} className={classes.contentLy}>
            <main className={classes.content}>
              <Chat organization={organization} />
            </main>
          </Grid>
        ) : (
          <>
            <Grid item xs={false} sm={6} />
            <Grid item xs={12} sm={3} className={classes.messengerContainer}>
              <CustomDFMessengerChat />
            </Grid>
          </>
        )}
      </Grid>
    </div>
  ) : (
    <LoadingSpinner />
  );
}
